import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    component: () => import(/* webpackChunkName: "index" */ "@v/index")
  },
  {
    path: "/about",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "@v/about")
  },
  {
    path: "/feedback",
    name: "feedback",
    component: () => import(/* webpackChunkName: "feedback" */ "@v/feedback")
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "@v/login")
  },
  {
    path: "/news",
    name: "news",
    component: () => import(/* webpackChunkName: "news" */ "@v/news")
  },
  {
    path: "/list",
    name: "list",
    component: () => import(/* webpackChunkName: "list" */ "@v/list")
  },
  {
    path: "/product",
    name: "product",
    component: () => import(/* webpackChunkName: "product" */ "@v/product")
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import(/* webpackChunkName: "detail" */ "@v/detail")
  },
  {
    path: "/service",
    name: "service",
    component: () => import(/* webpackChunkName: "service" */ "@v/service")
  },
  {
    path: "/serviceDetails",
    name: "serviceDetails",
    component: () =>
      import(/* webpackChunkName: "serviceDetails" */ "@v/serviceDetails")
  },
  {
    path: "/serviceList",
    name: "serviceList",
    component: () =>
      import(/* webpackChunkName: "serviceList" */ "@v/serviceList")
  },
  {
    path: "/serviceVideo",
    name: "serviceVideo",
    component: () =>
      import(/* webpackChunkName: "serviceVideo" */ "@v/serviceVideo")
  },
  {
    path: "/serviceVideoDetails",
    name: "serviceVideoDetails",
    component: () =>
      import(
        /* webpackChunkName: "serviceVideoDetails" */ "@v/serviceVideoDetails"
      )
  },
  {
    path: "/manual",
    name: "manual",
    component: () => import(/* webpackChunkName: "manual" */ "@v/manual")
  },
  {
    path: "/video",
    name: "video",
    component: () => import(/* webpackChunkName: "video" */ "@v/video")
  },
  {
    path: "/soft",
    name: "soft",
    component: () => import(/* webpackChunkName: "soft" */ "@v/soft")
  },
  {
    path: "/softDetails",
    name: "softDetails",
    component: () =>
      import(/* webpackChunkName: "softDetails" */ "@v/softDetails")
  },
  {
    path: "/user",
    name: "user",
    component: () => import(/* webpackChunkName: "user" */ "@v/user")
  },
  {
    path: "/synopsis",
    name: "synopsis",
    component: () => import(/* webpackChunkName: "synopsis" */ "@v/synopsis")
  },
  {
    path: "/synopsisDetails",
    name: "synopsisDetails",
    component: () =>
      import(/* webpackChunkName: "synopsisDetails" */ "@v/synopsisDetails")
  }
];

const router = new VueRouter({
  routes
});

export default router;
